import { useMutation } from '@tanstack/react-query';

import {
	createPurchaseMutation,
	type PurchaseRequest,
	type PurchaseResponseView,
} from '@mopla/ticketshop-api';

interface IUseCreatePurchaseResult {
	purchase: (body: PurchaseRequest) => Promise<PurchaseResponseView>;
	isPurchasing: boolean;
	reset: () => void;
}

/**
 * Step 3 — Purchase / payment (§10). POST /api/v1/purchases charges the saved
 * default payment method off-session; a 201 means "payment triggered → show
 * success". The client never sends a price — it's re-resolved server-side from
 * `variantId`. The bearer token is attached by the ticketshop client
 * interceptor (see configureTicketshopClient). Errors throw (throwOnError).
 */
export const useCreatePurchase = (): IUseCreatePurchaseResult => {
	const mutation = useMutation(createPurchaseMutation());

	return {
		purchase: (body) => mutation.mutateAsync({ body }),
		isPurchasing: mutation.isPending,
		reset: mutation.reset,
	};
};
